// web-staking-estimator-frontend/src/UserRequestForm.js
import React from "react";
import ServiceConfigurationForm from "./components/forms/ServiceConfigurationForm";
import ServiceLocationForm from "./components/forms/ServiceLocationForm";

/**
 * Composite form that combines service configuration and location forms.
 * This maintains backward compatibility while organizing code into focused components.
 */
export default function UserRequestForm({
  category,
  value,
  onChange,
  selectedPoint,
  xfmrOHUGHint,
  member,
  onMemberChange,
  nearestNone,
  defaultState,
}) {
  return (
    <>
      <ServiceConfigurationForm
        category={category}
        value={value}
        onChange={onChange}
        selectedPoint={selectedPoint}
        xfmrOHUGHint={xfmrOHUGHint}
        nearestNone={nearestNone}
      />
      <ServiceLocationForm
        member={member}
        onMemberChange={onMemberChange}
        defaultState={defaultState}
      />
    </>
  );
}
